import { useTranslation } from 'react-i18next'
import type { Blocker } from 'react-router'
import ConfirmDialog from './ConfirmDialog'

type Props = {
  message?: string
  blocker: Blocker
}
const ConfirmLeavePageDialog: React.FC<Props> = ({blocker, message}) => {
  const {t} = useTranslation()
  return <ConfirmDialog
    open={blocker.state === 'blocked'}
    onClose={()=> { blocker.reset?.() }}
    action={()=> {
      blocker.proceed?.()
    }}
    message={message ?? t('modal.confirm_leave_page')}
    ok_text={t('modal.leave_page')}
    cancel_text={t('general.cancel')}
    auto_close={false}
    // blocker.proceed()が成功した場合はダイアログが自動的に閉じられるため
    // ConfirmDialog側でcloseを呼ぶ必要がない（むしろ呼ぶとreset()が実行されて戻る動作がキャンセルされる）
  />
}
export default ConfirmLeavePageDialog